import React from 'react';
import './tips.css';
import AppStore from '../../assets/main/appstore.svg';
import Screen from '../../assets/tips/screen1.png';
import Policy from '../../assets/files/tipsbuddy_policy.pdf';

const Tips = () => {
  return (
    <section id='tips'>
      <div className='container tips__container_top'>
        <div className='tips__container'>
          <div className='tips__screenshot'>
            <img src={Screen} alt="Tips Buddy app screenshot showing tip calculation" />
          </div>
          <div className='tips__right'>
            <h1 className='noselect tips__title'>Tips Buddy</h1>
            <div className='tips__content'>
              <p className='noselect'>
                Dining out with friends should be fun, not a math lesson. Tips Buddy is a focused tip calculator for iPhone — enter the bill, pick a tip percentage, set the number of people, and get a clean split in seconds. No subscriptions, no tracking, no noise. Everything runs on-device.
              </p>
              <p className='noselect'>
                <a href={Policy} download='tipsbuddy_policy.pdf'>Privacy Policy Agreement</a>
              </p>
              <div className='noselect markov__buttons'>
                <a className='appstore_container' href='https://apps.apple.com/app/tips-buddy/id6505145035' aria-label="Download Tips Buddy on the App Store">
                  <img className='appstore' src={AppStore} alt="Download on the App Store" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tips;
